"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef, useState } from "react";
import WaveDropMobileMenu from "./WaveDropMobileMenu";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import useIsMobileDevice from "@/hooks/isMobileDevice";
interface DropMobileMenuHandlerProps {
  readonly drop: ExtendedDrop;
  readonly children: React.ReactNode;
  readonly showReplyAndQuote: boolean;
  readonly onReply: () => void;
  readonly onQuote: () => void;
}
const LONG_PRESS_DURATION = 500; // milliseconds
const MOVE_THRESHOLD = 10; // pixels

export default function DropMobileMenuHandler(t0) {
  const $ = _c(28);
  const {
    drop,
    children,
    showReplyAndQuote,
    onReply,
    onQuote
  } = t0;
  let t1;
  if ($[0] !== drop.id) {
    t1 = drop.id.startsWith("temp-");
    $[0] = drop.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isTemporaryDrop = t1;
  const [longPressTriggered, setLongPressTriggered] = useState(false);
  const [isSlideUp, setIsSlideUp] = useState(false);
  const isMobile = useIsMobileDevice();
  const longPressTimeout = useRef(null);
  const touchStartX = useRef(0);
  const touchStartY = useRef(0);
  let t2;
  if ($[2] !== isMobile) {
    t2 = () => {
      if (!isMobile) {
        return;
      }
      setLongPressTriggered(true);
      setIsSlideUp(true);
    };
    $[2] = isMobile;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleLongPress = t2;
  let t3;
  if ($[4] !== handleLongPress || $[5] !== isMobile || $[6] !== isTemporaryDrop) {
    t3 = e => {
      if (isTemporaryDrop) {
        return;
      }
      if (isMobile) {
        e.preventDefault();
      }
      touchStartX.current = e.touches[0].clientX;
      touchStartY.current = e.touches[0].clientY;
      longPressTimeout.current = setTimeout(() => {
        setLongPressTriggered(true);
        handleLongPress();
      }, LONG_PRESS_DURATION);
    };
    $[4] = handleLongPress;
    $[5] = isMobile;
    $[6] = isTemporaryDrop;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleTouchStart = t3;
  let t4;
  if ($[8] !== isMobile) {
    t4 = e_0 => {
      if (isMobile && longPressTimeout.current) {
        e_0.preventDefault();
      }
      const touchX = e_0.touches[0]?.clientX;
      const touchY = e_0.touches[0]?.clientY;
      const deltaX = Math.abs(touchX - touchStartX.current);
      const deltaY = Math.abs(touchY - touchStartY.current);
      if (deltaX > MOVE_THRESHOLD || deltaY > MOVE_THRESHOLD) {
        if (longPressTimeout.current) {
          clearTimeout(longPressTimeout.current);
          longPressTimeout.current = null;
        }
      }
    };
    $[8] = isMobile;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleTouchMove = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      if (longPressTimeout.current) {
        clearTimeout(longPressTimeout.current);
        longPressTimeout.current = null;
      }
      setLongPressTriggered(false);
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleTouchEnd = t5;
  let t6;
  if ($[11] !== onReply) {
    t6 = () => {
      setIsSlideUp(false);
      onReply();
    };
    $[11] = onReply;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleOnReply = t6;
  let t7;
  if ($[13] !== onQuote) {
    t7 = () => {
      setIsSlideUp(false);
      onQuote();
    };
    $[13] = onQuote;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const handleOnQuote = t7;
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setIsSlideUp(false);
    };
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const handleOnAddReaction = t8;
  let t9;
  if ($[16] !== drop || $[17] !== handleOnQuote || $[18] !== handleOnReply || $[19] !== isSlideUp || $[20] !== longPressTriggered || $[21] !== showReplyAndQuote) {
    t9 = <WaveDropMobileMenu drop={drop} isOpen={isSlideUp} longPressTriggered={longPressTriggered} showReplyAndQuote={showReplyAndQuote} setOpen={setIsSlideUp} onReply={handleOnReply} onQuote={handleOnQuote} onAddReaction={handleOnAddReaction} />;
    $[16] = drop;
    $[17] = handleOnQuote;
    $[18] = handleOnReply;
    $[19] = isSlideUp;
    $[20] = longPressTriggered;
    $[21] = showReplyAndQuote;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== children || $[24] !== handleTouchMove || $[25] !== handleTouchStart || $[26] !== t9) {
    t10 = <div onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} onTouchCancel={handleTouchEnd}>{children} {t9}</div>;
    $[23] = children;
    $[24] = handleTouchMove;
    $[25] = handleTouchStart;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}